import { motion } from 'framer-motion';
import { Loader, Mail } from 'lucide-react';

import { Button } from '@/components/ui/button';

interface ResetPasswordRequestSuccessProps {
  onResend: () => void;
  isPending: boolean;
}

export const ResetPasswordRequestSuccess = ({
  onResend,
  isPending,
}: ResetPasswordRequestSuccessProps) => {
  return (
    <motion.div
      key="password-reset-request-success"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.2 }}
    >
      <div className="space-y-4">
        <Button
          type="button"
          disabled={isPending}
          className="w-full"
          onClick={onResend}
        >
          {isPending ? (
            <Loader className="mr-2 h-4 w-4 animate-spin" />
          ) : (
            <Mail className="mr-2 h-4 w-4" />
          )}
          Resend reset link
        </Button>
        <Button
          className="w-full hover:no-underline hover:text-primary/75"
          variant="link"
          asChild
        >
          <a href="/reset-password/request">Return to request form</a>
        </Button>
      </div>
    </motion.div>
  );
};
